import { RotateCw } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import { setGoals } from 'modules/overlay-v2/store/game-info/game-info';
import { useDispatch } from 'react-redux';
import { theme } from 'styles/theme/theme';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Block from '../components/block';
import Counter from '../components/counter';

export function Score() {
  const { t } = useLingui();
  const dispatch = useDispatch();
  const { goals } = useGameInfo();

  const setScoreFirstTeam = (num: number) => {
    dispatch(setGoals({ ...goals, first: num }));
  };

  const setScoreSecondTeam = (num: number) => {
    dispatch(setGoals({ ...goals, second: num }));
  };

  const onClickReset = () => {
    dispatch(setGoals({ first: 0, second: 0 }));
  };

  return (
    <Block className={'flex-center flex-col'} headerText={t`Счёт`}>
      <div className={'flex'} style={{ width: '100%', justifyContent: 'space-between' }}>
        <Counter value={goals.first} setValue={setScoreFirstTeam} />
        <RotateCw size={16} color={theme.colors.WhiteGray} onClick={onClickReset} />
        <Counter value={goals.second} setValue={setScoreSecondTeam} />
      </div>
    </Block>
  );
}
